import React, { memo, useMemo } from 'react';
import { StyleSheet, View, } from 'react-native';
import Squircle from 'design-system/Squircle';
import useColors from 'hooks/useColors';
import Button from './Button';
import { CardView } from './CardView';
import Text from './Text';
import { rem } from './values';
export const AlertButton = ({ onPress, children, testID, isFetching, }) => {
    if (typeof children !== 'string') {
        log('Alert button can only accept string as a child prop', undefined, 'red');
        return null;
    }
    return (<Button small extra gray title={children} containerStyle={styles.button} onPress={onPress} testID={testID} isFetching={isFetching}/>);
};
export const AlertView = ({ title, subTitle, icon, iconSize = 40, children, style, testID, containerStyles, squircleColor, }) => {
    const colors = useColors();
    const content = useMemo(() => (<View style={[styles.container, style]}>
        {!!icon && (<Squircle width={rem(iconSize)} height={rem(iconSize)} color={squircleColor || colors.background.dark} style={styles.icon}>
            {icon}
          </Squircle>)}
        <Text Text-16 OffBlack centered style={subTitle ? styles.title : styles.subTitle}>
          {title}
        </Text>
        {Boolean(subTitle) && (<Text TextThin-14 Gray centered style={Boolean(children) && styles.subTitle}>
            {subTitle}
          </Text>)}
        {children}
      </View>), [
        children,
        colors.background.dark,
        icon,
        iconSize,
        squircleColor,
        style,
        subTitle,
        title,
    ]);
    return (<CardView testID={testID} style={containerStyles}>
      {content}
    </CardView>);
};
const styles = StyleSheet.create({
    container: {
        flexDirection: 'column',
        justifyContent: 'space-between',
        marginHorizontal: rem(16),
        paddingVertical: rem(24),
        paddingHorizontal: rem(48),
        borderRadius: rem(16),
        marginTop: 0,
        marginBottom: 0,
        alignItems: 'center',
    },
    icon: {
        marginBottom: rem(16),
    },
    button: {
        paddingHorizontal: rem(26),
    },
    title: {
        marginBottom: rem(4),
    },
    subTitle: {
        marginBottom: rem(16),
    },
});
export default memo(AlertView);
